import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import VideoBoxTimer from "../../casinoComponents/videoBox/overlays/VideoBoxTimer";
import PoisonCardsOverlay from "../../casinoComponents/videoBox/overlays/PoisonCardsOverlay";
import { getCasinoRulesHtml } from "../../../data/casinoRulesHtml";
import { IS_REF_MOBILE } from "../../../utils/refViewport";

/**
 * Teenpatti Poison One Day video block (same template as joker20) — reference markup (the shared VideoBox only has the rules icon;
 * this game's reference also shows Home and Last Results icons):
 *   .casino-video > .video-box-container > .video-box > iframe, card overlay, flip-clock timer,
 *   .casino-video-right-icons (home, rules, last-results toggle), rules panel/modal.
 */
export default function PoisonVideo({ gameType = "poison", iframeSrc, cards, timerValue, showResults, onToggleResults }) {
  const [showRules, setShowRules] = useState(false);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const rulesHtml = getCasinoRulesHtml(gameType);

  const openRules = () => {
    if (!rulesHtml) return;
    setShowRules(true);
    if (IS_REF_MOBILE) setShowRulesModal(true);
  };

  return (
    <div className="casino-video">
      <div className="video-box-container">
        <div className="video-box">
          <iframe src={iframeSrc || undefined} title="Live Stream" allowFullScreen />
        </div>
      </div>{" "}
      <PoisonCardsOverlay cards={cards} />{" "}
      <VideoBoxTimer timerValue={timerValue} />{" "}
      <div className="casino-video-right-icons">
        <div title="Home" className="casino-video-home-icon">
          <Link to="/admin/users2" className="router-link-active" style={{ color: "var(--text-highlight)" }}>
            <i className="fas fa-home" />
          </Link>
        </div>{" "}
        <div title="Rules" className="casino-video-rules-icon" onClick={openRules}>
          <i className="fas fa-info-circle" />
        </div>{" "}
        <div title="Last Results" className="casino-video-lr-icon" onClick={onToggleResults}>
          <i className={`fas ${showResults ? "fa-chevron-circle-up" : "fa-chevron-circle-down"}`} />
        </div>
      </div>{" "}
      <div>
        {showRules && (
          <div
            id="casino-vieo-rules"
            aria-modal="true"
            className="casino-vieo-rules show d-none-small show-rules"
            style={{ display: "block" }}
          >
            <div className="rules-header">
              <div>Rules</div> <i className="fas fa-times" onClick={() => setShowRules(false)} />
            </div>{" "}
            <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml }} />
          </div>
        )}
        <Modal
          show={showRulesModal}
          onHide={() => setShowRulesModal(false)}
          className="casino-rules teenpatti2-rule-modal"
          dialogClassName="modal-md"
          id="rules-modal"
        >
          <header className="modal-header">
            <h5 className="modal-title">Rules</h5>{" "}
            <button type="button" aria-label="Close" className="close" onClick={() => setShowRulesModal(false)}>
              ×
            </button>
          </header>
          <Modal.Body>
            <div className="casino-vieo-rules show-rules show">
              <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml || "" }} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
